import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

/**
 * 인증 상태 관리 훅
 *
 * AICC 관리자/상담원의 인증 상태, 로그인/로그아웃, 역할 기반 접근 제어를 제공.
 * AuthContext를 통해 사용자 정보와 권한(GLOBAL_ADMIN, TENANT_ADMIN, USER)을 확인.
 *
 * @returns {{
 *   user: object|null,
 *   loading: boolean,
 *   error: string|null,
 *   isAuthenticated: boolean,
 *   login: (email: string, password: string) => Promise<object>,
 *   logout: () => Promise<void>,
 *   hasRole: (roles: string|string[]) => boolean,
 *   isGlobalAdmin: () => boolean,
 *   isTenantAdminOrHigher: () => boolean,
 *   canAccessTenant: (tenantId: string) => boolean,
 *   refreshAuth: () => Promise<void>
 * }}
 *
 * @throws {Error} AuthProvider 외부에서 사용 시 오류 발생
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export default useAuth;
